module.exports = __webpack_public_path__ + "static/periferia-e01ad146680dbbe38890daf5bbe211bb.png";